export const countryList = [
  {
    val: 'AG',
    name: 'Antigua',
  },
  {
    val: 'BS',
    name: 'Bahamas',
  },
  {
    val: 'BB',
    name: 'Barbados',
  },
  {
    val: 'GD',
    name: 'Grenada',
  },
  {
    val: 'JM',
    name: 'Jamaica',
  },
  {
    val: 'LC',
    name: 'St. Lucia',
  },
  {
    val: 'TC',
    name: 'Turks And Caicos Islands'
  },
];

export const sandalsList = [
  {
    val: 'SAT',
    name: 'Sandals Grande Antigua',
    country: 'AG',
  },
  {
    val: 'SLS',
    name: 'Sandals Grenada',
    country: 'GD',
  },
  {
    val: 'SRB',
    name: 'Sandals Royal Bahamian',
    country: 'BS',
  },
  {
    val: 'SEB',
    name: 'Sandals Emerald Bay',
    country: 'BS',
  },
  {
    val: 'SBD',
    name: 'Sandals Barbados',
    country: 'BB',
  },
  {
    val: 'SBR',
    name: 'Sandals Royal Barbados',
    country: 'BB',
  },
  {
    val: 'SLU',
    name: 'Sandals Regency La Toc',
    country: 'LC',
  },
  {
    val: 'SHC',
    name: 'Sandals Halcyon Beach',
    country: 'LC',
  },
  {
    val: 'SGL',
    name: 'Sandals Grande St. Lucian',
    country: 'LC',
  },
  {
    val: 'SGO',
    name: 'Sandals Ochi Beach Resort',
    country: 'JM',
  },
  {
    val: 'SWH',
    name: 'Sandals South Coast',
    country: 'JM',
  },
  {
    val: 'SRC',
    name: 'Sandals Royal Caribbean',
    country: 'JM',
  },
  {
    val: 'SMB',
    name: 'Sandals Montego Bay',
    country: 'JM',
  },
  {
    val: 'SNG',
    name: 'Sandals Negril',
    country: 'JM',
  },
  {
    val: 'INN',
    name: 'Sandals Inn',
    country: 'JM',
  },
  {
    val: 'BRP',
    name: 'Sandals Royal Plantation',
    country: 'JM',
  },
];

export const beachesList = [
  {
    val: 'BNG',
    name: 'Beaches Negril',
    country: 'JM',
  },
  {
    val: 'BBO',
    name: 'Beaches Ocho Rios',
    country: 'JM',
  },
  {
    val: 'BTC',
    name: 'Beaches Turks & Caicos',
    country: 'TC',
  },
];

export const resortList = [
  ...sandalsList,
  ...beachesList
];
